import * as TaskRunner from 'util/TaskRunner';

export type ColumnMapping =
  | {type: 'builtIn'; columnName: string; role: string}
  | {type: 'schemaField'; columnName: string; schemaFieldKey: string};

export interface BulkImportRequest {
  s3Url: string;
  columnMappings: Array<ColumnMapping>;
  registrationConfig: {
    registryId: string;
    namingStrategy: string;
    folderId: string;
    schemaId: string;
    compoundSchemaId?: string | null;
  };
}

export interface BulkImportResponse {
  taskId: string;
  successCount: number;
}

export async function bulkImportMoleculesFromSpreadsheet(
  request: BulkImportRequest
): Promise<BulkImportResponse> {
  const response = await TaskRunner.postJSONPromise({
    url: '/1/api/molecules:bulk-import-from-spreadsheet',
    data: {
      s3Url: request.s3Url,
      columnMappings: request.columnMappings,
      registrationConfig: {
        schemaId: request.registrationConfig.schemaId,
        folderId: request.registrationConfig.folderId,
        namingStrategy: request.registrationConfig.namingStrategy,
        registryId: request.registrationConfig.registryId,
      },
    },
  });
  return response;
}
